import React, { useEffect, useMemo, useState } from 'react';
import http from "../services/http";

const AdminStats = () => {
    const [stats, setStats] = useState({
        activeUsers: 0,
        usersToday: 0,
        usersThisWeek: 0,
        usersThisMonth: 0,
        usersThisYear: 0,
    });

    useEffect(() => {
        fetchStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [monthly, setMonthly] = useState([]);

    const fetchStats = async () => {
        try {
            const [summaryRes, monthlyRes] = await Promise.all([
                http.get(`/api/admin/activity/stats`),
                http.get(`/api/admin/activity/stats/monthly`),
            ]);

            setStats(summaryRes.data);
            setMonthly(monthlyRes.data || []);
        } catch (error) {
            console.error("Fehler beim Laden der Statistiken: ", error);
        }
    }

    const chart = useMemo(() => {
        if (!monthly || monthly.length === 0) return null;
        const width = 720;
        const height = 240;
        const padding = 32;
        const xs = monthly.map((_, i) => i);
        const ys = monthly.map(d => d.userCount || 0);
        const maxY = Math.max(1, ...ys);
        const xScale = (i) => padding + (i / Math.max(1, xs.length - 1)) * (width - padding * 2);
        const yScale = (v) => height - padding - (v / maxY) * (height - padding * 2);
        const path = monthly.map((d, i) => `${i === 0 ? 'M' : 'L'} ${xScale(i)} ${yScale(d.userCount || 0)}`).join(' ');
        const ticks = 4;
        const yTicks = new Array(ticks + 1).fill(0).map((_, i) => Math.round((maxY / ticks) * i));

        return (
            <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-64">
                <rect x="0" y="0" width={width} height={height} fill="white" />
                {yTicks.map((t, idx) => {
                    const y = yScale(t);
                    return (
                        <g key={idx}>
                            <line x1={padding} x2={width - padding} y1={y} y2={y} stroke="#e5e7eb" />
                            <text x={8} y={y + 4} fontSize="10" fill="#6b7280">{t}</text>
                        </g>
                    );
                })}
                <path d={path} fill="none" stroke="#3b82f6" strokeWidth="2.5" />
                {monthly.map((d, i) => (
                    <circle key={i} cx={xScale(i)} cy={yScale(d.userCount || 0)} r="3" fill="#1d4ed8" />
                ))}
            </svg>
        );
    }, [monthly]);

    return (
        <div className="p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Nutzerstatistiken</h2>
            <ul>
                <li><strong>Aktive Nutzer:</strong> <p className="text-blue-600">{stats.activeUsers}</p></li>
                <li><strong>Heute:</strong> <p className="text-blue-600">{stats.usersToday}</p></li>
                <li><strong>Diese Woche:</strong> <p className="text-blue-600">{stats.usersThisWeek}</p></li>
                <li><strong>Diesen Monat:</strong> <p className="text-blue-600">{stats.usersThisMonth}</p></li>
                <li><strong>Dieses Jahr:</strong> <p className="text-blue-600">{stats.usersThisYear}</p></li>
            </ul>
            <div className="mt-6">
                <h3 className="text-xl font-semibold mb-2">Besucher pro Tag (Monat)</h3>
                {chart || <p className="text-gray-500">Keine Daten vorhanden.</p>}
            </div>
        </div>
    );
};

export default AdminStats;